import { getTemporaryBlockId } from "../../../../../../services/helpers/Helper";
import { PREVIEW } from "../../constants/preview";
import Delay from "./components/delay";
import Text from "./components/text";
import Cards from "./cards";
import Image from "./components/image";
import Gallery from "./components/gallery";

const Editor = (props) => {
   const { faq, data, onChange, faqId } = props;

   const getComponent = (card, index) => {
      const { type } = card;
      switch (type) {
         case PREVIEW.TEXT:
            return <Text
               {...props}
               key={index}
               card={card}
            />
         case PREVIEW.IMAGE:
            return <Image
               {...props}
               key={index}
               card={card}
            />
         case PREVIEW.GALLERY:
            return <Gallery
               {...props}
               key={index}
               card={card}
            />
         default:
            break;
      }
   }

   return (
      <div className="block-editor-wrapper">
         <div className="block-editor col-auto">
            <div className="block-breadcrumb">
               <div className="block-breadcrumb-container">
                  <span>
                     <a><span className="pointer">{faq?.title}</span></a>
                  </span>
               </div>
            </div>
            <div className="block-card-list">
               {faq?.cards?.map(getComponent)}
               {/* <div className="quick-reply-editor">
                  <div className="quick-reply-wraper">
                     <div className="ps-relative">
                        <div className="quick-reply-container add-more">
                           <div className="quick-reply-content"><span>+ Trả lời nhanh</span></div>
                        </div>
                        <div className="text-left"></div>
                     </div>
                  </div>
               </div> */}
            </div>
            <Cards
               {...props}
            />
            {/* <div className="card-editor fadeInDown animated">
               <div className="block-card-list">
                  <div style={{ position: 'relative' }}>
                     <div className="card-item card-item-text card-start-another-flow p-md-b unactive">
                        Sang bước tiếp theo
                        <div className="p-relative text-center">
                           <div className="button-open-this-flow">
                              Chọn bước tiếp theo
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div> */}
         </div>
      </div>
   )
}

export default Editor;